// extracted by mini-css-extract-plugin
export default {"input_box":"ShiftCalendar_input_box__PQlST","empty_box":"ShiftCalendar_empty_box__qPJ6U"};